<template>
  <v-dialog :value="value" max-width="480" scrollable @input="onDialogInput">
    <v-card>
      <v-card-title class="text-h6" v-text="title"></v-card-title>
      <v-card-text class="pb-0">
        <v-autocomplete
          ref="search"
          v-model="chosenId"
          :items="options"
          item-text="name"
          item-value="id"
          :label="label"
          :loading="loading"
          :no-data-text="
            loading ? 'Loading tournaments...' : 'No tournaments found'
          "
          :disabled="loading && !options.length"
          outlined
          dense
          hide-details
          autofocus
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title v-text="item.name"></v-list-item-title>
              <v-list-item-subtitle
                v-if="item.category"
                v-text="item.category"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-btn text v-text="'Cancel'" @click="close"></v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="!chosenId"
          v-text="'Apply'"
          @click="apply"
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { db } from "@/App.vue";
import { ref, onValue } from "firebase/database";

// Reusable tournament picker: use with v-model for visibility, listen to
// `change` to receive the selected tournament ({ id, name, category }).
export default {
  name: "TournamentPicker",

  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: "Select tournament" },
    label: { type: String, default: "Tournament" },
    selectedId: { type: String, default: null },
  },

  data: () => ({
    tournaments: [],
    loading: true,
    chosenId: null,
    unsubscribers: [],
  }),

  computed: {
    options() {
      return this.tournaments;
    },
  },

  watch: {
    value(open) {
      if (!open) return;
      this.chosenId = this.selectedId || null;
      this.$nextTick(() => {
        setTimeout(() => {
          const field = this.$refs.search;
          if (field) field.focus();
        }, 50);
      });
    },
  },

  created() {
    this.unsubscribers.push(
      onValue(ref(db, "tournaments"), (snapshot) => {
        const tournaments = [];
        snapshot.forEach((childSnapshot) => {
          const data = childSnapshot.val() || {};
          tournaments.push({
            id: childSnapshot.key,
            name: data.name || childSnapshot.key,
            category: data.category || "",
          });
        });
        tournaments.sort((a, b) => a.name.localeCompare(b.name));
        this.tournaments = tournaments;
        this.loading = false;
      })
    );
  },

  beforeDestroy() {
    this.unsubscribers.forEach((unsubscribe) => unsubscribe());
    this.unsubscribers = [];
  },

  methods: {
    onDialogInput(open) {
      this.$emit("input", open);
    },
    close() {
      this.$emit("input", false);
    },
    apply() {
      const tournament = this.tournaments.find(
        (item) => item.id === this.chosenId
      );
      if (!tournament) return;
      this.$emit("change", tournament);
      this.$emit("input", false);
    },
  },
};
</script>
